import { generateClient } from 'aws-amplify/api';
import { dailyReportByLocationId } from "../graphql/customQueries";

const client = generateClient();

export default async (locationId, startDate, endDate, limit = 12, nextToken) => {
    try {

        let submissionDate;
        if (startDate && endDate) {
            submissionDate = { between: [startDate, endDate] }
        }

        const { data } = await client.graphql({
            query: dailyReportByLocationId,
            variables: {
                nextToken,
                locationId,
                submissionDate,
                limit,
                sortDirection: "DESC",
            },
        });
        return data.dailyReportByLocationId;
    } catch (error) {
        console.log("Failed to fetch daily report list", error);
        return {
            items: [],
            error,
        };
        //return;
    }
};
